import { SelectionItem } from '../../core/component/select/select.component';
import { Translation } from '../../core/model/translation';

export class HomeqOptions {
  constructor(data: any) {
    this.requirementProfiles = data.requirementProfiles.map(profile => new SelectionItem(profile.name, profile.id));
  }
  requirementProfiles: SelectionItem[];
}

export class DhMarketOptions {
  constructor(data: any) {
    this.requirementProfiles = data?.requirementProfiles.map(profile => new SelectionItem(profile.name, profile.id));
    this.areaSelection = data?.areas.map(area => new SelectionItem(area.name, area.id));
    this.areaSelection?.splice(0, 0, new SelectionItem('LETTING.ADVERTISMENT.DHMARKET.NEW_AREA', ''));
    this.areas = data ? data.areas.map(area => new DhMarketArea(area)) : [];
    this.isShowingEnabled = data?.isShowingEnabled ? true : false;
    this.showingTenantText = data?.showingTenantText || '';
    this.showingOrdinaryText = data?.showingOrdinaryText || '';
    this.defaultPublicationPeriods = data?.requirementProfiles.map(profile => {
      return { defaultPublicationPeriodInDays: profile.defaultPublicationPeriodInDays, id: profile.id };
    });
  }
  areaSelection: SelectionItem[];
  areas: DhMarketArea[];
  requirementProfiles: SelectionItem[];
  isShowingEnabled: boolean;
  showingTenantText: string;
  showingOrdinaryText: string;
  defaultPublicationPeriods: { defaultPublicationPeriodInDays: number; id: string }[];
}

export class DhMarketAreaOptions {
  constructor(data: any) {
    this.marketAreas = data.map(area => new SelectionItem(area.name, area.id));
  }
  marketAreas: SelectionItem[];
}

export class DhMarketArea {
  constructor(data: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.description = data.description.map(desc => new Translation(desc.cultureName, desc.translationText));
      this.searchTags = data.searchTags;
    }
  }

  id: string;
  name: string;
  description: Translation[];
  searchTags: string[];
}
